<template>
  <div>
    <mu-stepper :activeStep="3">
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabYou')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabHealth')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabLocation')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabGoals')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabPersonalise')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <mu-card>
      <div v-show="isLoading">
        <mu-card-text align="center">
          <img src="static/Dashboard.gif" width="25%"/>
          <br/>
          {{$t('message.loadingText')}}
        </mu-card-text>
      </div>
      <div v-show="!isLoading">
        <mu-card-header
          :title="title"
          :subTitle="subTitle"
        ></mu-card-header>
        <mu-card-text class="grey">
          <div class="subHeader">{{$t('message.gettingStartedGoalsSubHeader')}}</div>
          <mu-row gutter id="goalsSection">
            <mu-col v-for="(item, index) in lists.goals" :key="'goal-' + index" desktop="33" tablet="50" width="100"
                    style="margin-bottom: 16px;">
              <mu-paper class="goalCard hvr-grow" @click.native="updateGoal(item)" style="width: 100%">
                <mu-flexbox style="min-height: 44px" align="center center" justify="center center">
                  <mu-flexbox-item align="center" grow="0.5" style="margin-left: 8px !important; margin-right: 8px;">
                    <img style="display:flex" width="40" :src="'static/goals/' + item.icon + '.svg'"/>
                  </mu-flexbox-item>
                  <mu-flexbox-item grow="2">
                    {{localizeGoal(item.goal)}}
                  </mu-flexbox-item>
                  <mu-flexbox-item grow="1" class="layerBehind">
                    <mu-checkbox
                      checkedIcon="check_circle"
                      uncheckIcon="radio_button_unchecked"
                      style="display: flex; float:right; margin-right: 8px;"
                      color="red"
                      :key="'goal-' + index"
                      v-model="item.checked"
                    />
                  </mu-flexbox-item>
                </mu-flexbox>
              </mu-paper>
            </mu-col>
          </mu-row>
        </mu-card-text>
        <mu-card-text>
          <div v-if="checkedGoals.length > 0">
            <h2>
              {{$t('message.gettingStartedGoalsWhenYouHave')}}
              <span v-for="item, index in checkedGoals" :key="'goals-checked-' + index">
              <span v-text="localizeGoal(item.plural) + (index === (checkedGoals.length  ) - 1 ? '...' : '')"></span>
              <span style="margin-left: -2px"
                    v-if="index < (checkedGoals.length - 2)">{{index < (checkedGoals.length - 2) ? ', ' : ''}}</span>
              <span v-if="index === (checkedGoals.length) - 2">{{$t('message.andText')}} </span>
            </span>
            </h2>
            <br/>
            <mu-row>
              <mu-col desktop="50" tablet="100" width="100">
                <mu-select-field
                  id="goalRelationTxt"
                  :scroller="scroller"
                  v-model="goalModel.goal_relation_id"
                  v-validate
                  :data-vv-rules="'required'"
                  data-vv-name="difference"
                  data-vv-value-path="inputValue"
                  data-vv-as=""
                  :errorText="errors.first('difference')"
                  :fullWidth="true"
                  :label="$t('message.gettingStartedGoalsWhatDifference')"
                >
                  <mu-menu-item
                    v-for="item, index in lists.goal_relations"
                    :key="'goal-id-' + index"
                    :value="item.goal_relation_id"
                    :title="localizeGoalReason(item.title)">
                  </mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>
            <div v-if="goalModel.goal_relation_id">
              <mu-row>
                <mu-col desktop="100" tablet="100" width="100">
                  <mu-text-field
                    id="goalTxt"
                    :label="$t('message.gettingStartedGoalsWhenYouAreFeeling') + ' ' +  loadRelationPlural(goalModel.goal_relation_id) + ' ' + $t('message.gettingStartedGoalsWhatWillYouNoticeIsDifferent')"
                    v-model="goalModel.goal_text"
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="reason"
                    data-vv-as=""
                    data-vv-validate-on="none"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('reason')"
                    :hintText="$t('message.labelStartTyping')"
                    fullWidth
                    :rows="3"
                  />
                </mu-col>
              </mu-row>
            </div>
            <div class="mu-text-field-label" style="width: 100%; font-size: 16px;">
              {{$t('message.gettingStartedGoalsRatingScale')}}
              <span style="float:right; color: black; text-align: right; font-size: 18px;">
                <span style="color: #0179d5" v-text="goalModel.goal_evaluation"></span>/10
              </span>
            </div>
            <mu-slider
              :step="1"
              :min="0"
              :max="10"
              v-model="goalModel.goal_evaluation"
              class="demo-slider"
            />
            <div class="dashedBorder"></div>
          </div>
          <mu-raised-button
            id="submitBtn"
            fullWidth
            secondary
            backgroundColor="#9ACA3F"
            color="white"
            :label="isSaving ? $t('message.savingText'): $t('message.nextText')"
            :disabled="isSaving"
            @click.native="submitForm"
          >
          </mu-raised-button>
        </mu-card-text>
      </div>
    </mu-card>
  </div>
</template>

<script>

  import AccountApi from '../../api/Account'
  import UserApi from '../../api/User'
  import GoalLocalizerMixin from '../../mixins/Localization/Goals'
  import GoalReasonLocalizerMixin from '../../mixins/Localization/GoalReasons'
  import ScrollerMixin from '../../mixins/ScrollerMixin'


  export default {
    name: 'goals',
    mixins: [ScrollerMixin, GoalLocalizerMixin, GoalReasonLocalizerMixin],
    data() {
      return {
        isVideoPlaying: false,
        activeDiabetesType: {},
        isSaving: false,
        isDiabetic: false,
        fullWidth: true,
        underlineShow: true,
        isLoading: true,
        activeStep: 3,
        title: this.$t('message.gettingStartedGoalsTitle'),
        subTitle: this.$t('message.gettingStartedGoalsSubTitle'),
        lists: {},
        checkedGoals: [],
        model: {},
        goalModel: {
          goals: [],
          goal_relation_id: null,
          goal_evaluation: 5,
          goal_text: ''
        }
      }
    },
    mounted() {
      let self = this;

      self.$gtag.pageview('/getting-started/goals');

      $(self.$refs['goalVideo']).hover(function () {
        $(self.$refs['goalVideo']).prop('controls', true)
      });

      self.lists = JSON.parse(JSON.stringify(self.$store.state.list));
      self.lists.diabetes_types = self.lists.diabetes_types.filter(function (type) {
        return type.is_diabetic === true
      });

      //Load user account
      AccountApi.getAccount().then(function (response) {
        $.extend(self.model, response.data);
        self.model.diabetes_type_id = response.data.diabetes_type_id;
        self.model.diagnosis_year = '' + response.data.diagnosis_year + '';

        self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
          return type.diabetes_type_id === response.data.diabetes_type_id
        })[0];
        if (_.has(self.activeDiabetesType, 'is_diabetic')) {
          if (self.activeDiabetesType.is_diabetic === true) {
            self.isDiabetic = true
          }
          else {
            self.isDiabetic = false
          }
        }
        self.$forceUpdate();
        setTimeout(function () {
          self.isLoading = false
        }.bind(self), 500)
      })
        .catch(function (error) {
          window.location.href = '../login'
        });
        self.$nextTick(() => {
            //Reddit Conversion Tracking
            !function (w, d) {
                if (!w.rdt) {
                    var p = w.rdt = function () {
                        p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments)
                    };
                    p.callQueue = [];
                    var t = d.createElement("script");
                    t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
                    var s = d.getElementsByTagName("script")[0];
                    s.parentNode.insertBefore(t, s)
                }
            }(window, document);
            rdt('init', 't2_pd1aslc');
            rdt('track', 'SignUp');
        })
    },
    methods: {
      playPauseVideo(ref) {
        let self = this;
        let video = self.$refs[ref];
        if (video.paused) {
          video.play();
          self.isVideoPlaying = true
        }
        else {
          self.isVideoPlaying = false;
          video.pause()
        }
      },
      updateGoal(item) {
        let self = this;
        item.checked = !item.checked;
        self.$nextTick(function () {
          self.updateGoals();
        });
      },
      updateGoals() {
        let self = this;
        self.getCheckedGoals()
      },
      getCheckedGoals() {
        let self = this;
        self.checkedGoals = self.lists.goals.filter(function (goal) {
          return goal.checked === true
        })
      },
      loadRelationPlural(id) {
        let self = this;
        return self.localizeGoalReason(self.lists.goal_relations.filter(function (goal_relation) {
          return goal_relation.goal_relation_id === id
        })[0].plural);
      },
      forceUpdate() {
        let self = this;
        self.$forceUpdate()
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              let data = [];
              self.isSaving = true;
              self.$nextTick(function () {
                for (let i = 0; i < self.checkedGoals.length; i++) {
                  self.goalModel.goals.push(self.checkedGoals[i].goal_id)
                }
                data = self.lists.goals.filter(function (goal) {
                  return goal.checked === true
                });

                if (data.length === 0) {
                  self.isSaving = false;
                  alert(self.$t('message.gettingStartedGoalsEmptyError'))
                }
                else {
                  AccountApi.putUserGoals(self.goalModel)
                    .then(function (response) {
                      UserApi.onBoardingStatus()
                        .then(function (response) {
                          self.$gtag.event('GoalsPanelComplete',{
                            'event_category': 'Onboarding',
                            'event_label': 'Completed goals panel',
                            'value': 1
                          });
                          self.$store.commit('setOnBoardingStatus', response.data);
                          self.$router.push({
                            name: 'GettingStartedPersonalise'
                          })
                        });
                    })
                }
              });
            }
          })
          .catch(function (error) {
            self.isSaving = false
          })
      }
    }
  }
</script>
<style scoped>
  textarea.mu-text-field-textarea-hide.mu-text-field-input {
    display: none;
  }

  h1 {
    font-size: 24px;
    margin-top: 0;
  }

  h2 {
    margin: 0
  }

  p {
    color: #9b9b9b;
    font-size: 16px;
  }
</style>
<style>
  .noPaddingTop {
    padding-top: 0px !important;
  }

  .noPaddingBottom {
    padding-bottom: 0px !important;
  }

  .mu-card-text.grey {
    background: #f5f7fa;
    margin-top: 24px;
  }
  .layerBehind {
    position: relative;
    z-index: -1;
  }

  .mu-card-text.grey .subHeader {
    font-family: Poppins;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: #4a4a4a;
    margin-bottom: 16px;
  }

  .goalCard {
    padding: 8px !important;
    box-shadow: 0 8px 8px 0 #e5e5e5, 0 0 24px 0 #e5e5e5;
    -moz-box-shadow: 0 8px 8px 0 #e5e5e5, 0 0 24px 0 #e5e5e5;
    color: #4a4a4a;
    font-size: 14px;
    cursor: pointer;
  }

  .goalCard.hvr-grow:hover {
    padding: 8px !important;
    box-shadow: 0 24px 24px 0 #e5e5e5, 0 0 24px 0 #e5e5e5;
    -webkit-box-shadow: 0 24px 24px 0 #e5e5e5, 0 0 24px 0 #e5e5e5;
    -moz-box-shadow: 0 24px 24px 0 #e5e5e5, 0 0 24px 0 #e5e5e5;;
    color: #4a4a4a;
    font-size: 14px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Goals.vue?6f1a5728